module.exports = __webpack_public_path__ + "static/media/icono_lugar.5eaaee24.svg";